import {Checkbox, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@mui/styles";
import globalVars from "../utils/globalVars";

const useStylesNormal = makeStyles({
        myquestionkeywords: {
            backgroundColor: '#white'
        }
    }
);

const useStylesFeedback = makeStyles({
        myquestionkeywords: {
            backgroundColor: ok => ok ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk,
            // borderWidth: "1px",
            // borderStyle: "solid",
            // borderColor: ok => ok ? '#3ff' : '#f3f',
        }
    }
);

export default function QuestionkeywordsSubcomponent(props) {

    const [expectedKeywords, setExpectedKeywords] = useState(
        props.expectedKeywords.join('|').split('|').map(
            (e) => {
                return e.trim();
            }
        )
    );
    const [currentKeyword, setCurrentKeyword] = useState('');
    const [ok, setOk] = useState(false)
    const mode = 'mode_feedback'

    // const classes = useStyles(ok);
    const classesModeNormal = useStylesNormal();
    const classesModeFeeback = useStylesFeedback(ok);
    const classes = {
        'mode_normal': classesModeNormal,
        'mode_feedback': classesModeFeeback,
    }

    function handleChange(e) {
        setCurrentKeyword(e.target.value)
    }

    useEffect(
        () => {
            setOk(expectedKeywords.includes(currentKeyword))
        },
        [currentKeyword]
    )

    return (
        <div
            style={{display: 'block'}}
        >
            <TextField
                id="standard-basic"
                variant="standard"
                value={currentKeyword}
                onChange={handleChange}
                className={classes[props.feedbackMode].myquestionkeywords}
                style={{width: "50vw"}}
                // size='small'
                // color={(ok) ? 'primary' : 'error'}
            />
        </div>
    )
}